import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";


import { useMutation, gql } from "@apollo/client";


const UPDATE_PARTICIPANT_PROGRAM_DATA = gql`
  mutation updateParticipantProgramDataByProgramNumber($programNumber: Int!, $updates: participantProgramDataInput) {
    updateParticipantProgramDataByProgramNumber(programNumber: $programNumber, updates: $updates) {
      responseCode
      message
    }
  }
`;

export const EditDisposition = ({
  isOpen,
  onClose,
  programNumber,
  planData,
}: {
  isOpen: boolean;
  onClose: () => void;
  programNumber: number;
  planData: any;
}) => {
  const [formData, setFormData] = useState({ ...planData });
  const [updateParticipantProgramData] = useMutation(UPDATE_PARTICIPANT_PROGRAM_DATA);

  const normalizePlanData = (value: any) => ({
    comments: value?.comments || "",
    contact: value?.contact || "",
    custodyOrCommunity: value?.custodyOrCommunity || "",
    dischargePlan: value?.dischargePlan || "",
    highPriorityStatus: value?.highPriorityStatus || "",
    ihAssignmentDate: value?.ihAssignmentDate || "",
    ihRequestDate: value?.ihRequestDate || "",
    ihRequestStatus: value?.ihRequestStatus || "",
    location: value?.location || "",
    locationDetail: value?.locationDetail || "",
    notes: value?.notes || "",
    pharmacyNotes: value?.pharmacyNotes || "",
    pshFundingSource: value?.pshFundingSource || "",
    pshSearchNotes: value?.pshSearchNotes || "",
    pshSearchStatus: value?.pshSearchStatus || "",
    pshSearchStatusDate: value?.pshSearchStatusDate || "",
    pshType: value?.pshType || "",
    restrictions: value?.restrictions || "",
  });

  useEffect(() => {
    if (planData) {
      setFormData(normalizePlanData(planData));
    }
  }, [planData]);

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const {__typename, ...vars} = formData;
      await updateParticipantProgramData({
        variables: {
          programNumber,
          updates: {locationAndPlan:vars},
        },
      });
      onClose();
    } catch (error) {
      console.error("Error updating disposition:", error);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open: boolean) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent
        style={{
          position: "relative",
          background: "white",
          padding: "20px",
          maxHeight: "80vh",
          overflowY: "scroll",
          width: "100%",
          maxWidth: "800px",
          inset: 0,
        }}
        overlayStyle={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        className="max-w-none"
        onInteractOutside={(event) => event.preventDefault()}
      >
      <div style={{ marginBottom: "1.5rem" }}>
        <h2 className="text-3xl font-bold text-center">
          Edit Location and Plan
        </h2>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          <div>
            <label>Custody or Community:</label>
            <select
              name="custodyOrCommunity"
              value={formData.custodyOrCommunity}
              onChange={handleInputChange}
            >
              <option value="0">Community</option>
              <option value="1">In Custody</option>
            </select>
          </div>
          <div>
            <label>Location:</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>Location Detail:</label>
            <textarea
              name="locationDetail"
              value={formData.locationDetail}
              onChange={handleInputChange}
              rows={4}
              cols={80}
            />
          </div>
          <div>
            <label>Contact:</label>
            <textarea
              name="contact"
              value={formData.contact}
              onChange={handleInputChange}
              rows={4}
              cols={80}
            />
          </div>
          <div>
            <label>Discharge Plan:</label>
            <textarea
              name="dischargePlan"
              value={formData.dischargePlan}
              onChange={handleInputChange}
              rows={4}
              cols={80}
            />
          </div>
          <div>
            <label>Comments:</label>
            <textarea
              name="comments"
              value={formData.comments}
              onChange={handleInputChange}
              rows={4}
              cols={80}
            />
          </div>
          <div>
            <label>High Priority Status:</label>
            <input
              type="text"
              name="highPriorityStatus"
              value={formData.highPriorityStatus}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>IH Assignment Date:</label>
            <input
              type="date"
              name="ihAssignmentDate"
              value={formData.ihAssignmentDate}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>IH Request Date:</label>
            <input
              type="date"
              name="ihRequestDate"
              value={formData.ihRequestDate}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>IH Request Status:</label>
            <input
              type="text"
              name="ihRequestStatus"
              value={formData.ihRequestStatus}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>Notes:</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              rows={4}
              cols={80}
            />
          </div>
          <div>
            <label>Pharmacy Notes:</label>
            <textarea
              name="pharmacyNotes"
              value={formData.pharmacyNotes}
              onChange={handleInputChange}
              rows={4}
              cols={80}
            />
          </div>
          <div>
            <label>PSH Funding Source:</label>
            <input
              type="text"
              name="pshFundingSource"
              value={formData.pshFundingSource}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>PSH Search Notes:</label>
            <textarea
              name="pshSearchNotes"
              value={formData.pshSearchNotes}
              onChange={handleInputChange}
              rows={4}
              cols={80}
            />
          </div>
          <div>
            <label>PSH Search Status:</label>
            <input
              type="text"
              name="pshSearchStatus"
              value={formData.pshSearchStatus}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>PSH Search Status Date:</label>
            <input
              type="date"
              name="pshSearchStatusDate"
              value={formData.pshSearchStatusDate}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>PSH Type:</label>
            <input
              type="text"
              name="pshType"
              value={formData.pshType}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>Restrictions:</label>
            <textarea
              name="restrictions"
              value={formData.restrictions}
              onChange={handleInputChange}
              rows={4}
              cols={80}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
          >
            <button type="submit">Update</button>
          </div>
        </form>
      </div>
      </DialogContent>
    </Dialog>
  );
};
